import React from 'react'
import "./index.scss"

const Table =(props) =>{
    const {item} =  props;
    return (
    <>
        <div className="table_container">
            {item.map( data =>{
                return (
                <div className="table_body">
                    <p className="table_header">{data.header}</p>
                    <div className="table_data">
                        <span>{data.item}</span>
                        <span>{data.item2}</span>
                    </div>
            </div>)
            })}
        </div>
 
    </>)
}

export default Table